<template lang="html">
  <div>
    <div class="tips">健康常识</div>
    <div class="knowBox">
      <div class="knowledge">
        <img alt="" src="../assets/know-1.jpg"/>
        <div class="contentBox">
          <div class="contentTitlt">
            鸦胆子油软胶囊能够长期服用吗?
          </div>
          <div class="contentTxt">
            一般人们所说的“癌症”习惯上泛指所有恶性肿瘤。恶性肿瘤生长速度快，呈浸润性生长，易发生出血、坏死、溃疡等，并常有远处转移，造成人体消瘦、无力、发热以及严重的脏器功能受损等。因此恶性肿瘤患者往往需要长期坚持用药治疗。鸦胆子油软胶囊是临床上可用于治疗癌症的药物，那么鸦胆子油软胶囊能够长期服用吗?
          </div>
          <div class="contentTime">发布日期: <span>2019-10-19</span></div>
        </div>
      </div>
      <div class="knowledge">
        <img alt="" src="../assets/know-2.jpg"/>
        <div class="contentBox">
          <div class="contentTitlt">
            方药用量规律与合理用量分析
          </div>
          <div class="contentTxt">
            在我国，中药有悠久历史。疗效是中医的生命，辨证论治是中医的精髓。当辨证、选方、用药确定后，合理用量便成为提高临床疗效的关键。“理、法、方、药”为传统辨证论治体系的四个关键要素，而关于“量”的问题则缺乏系统的理论阐述。
          </div>
          <div class="contentTime">发布日期: <span>2019-10-19</span></div>
        </div>
      </div>
      <div class="knowledge">
        <img alt="" src="../assets/know-3.gif"/>
        <div class="contentBox">
          <div class="contentTitlt">
            油盐酱醋对药物有什么影响?
          </div>
          <div class="contentTxt">
            油盐酱醋家家都需要，它们是居家必不可少的调料，多方面了解其对用药的影响，在应用药物治疗时将大有益处。
          </div>
          <div class="contentTime">发布日期: <span>2019-10-19</span></div>
        </div>
      </div>
      <div class="knowledge">
        <img alt="" src="../assets/know-4.jpg"/>
        <div class="contentBox">
          <div class="contentTitlt">
             家庭常用药品失效的特征
          </div>
          <div class="contentTxt">
            药品容易受到光线、温度、湿度、微生物的影响与破坏。如药品存放不当，或存放过久，会使药品质量下降或变质无效，用这样的药品会造成不良后果。
          </div>
          <div class="contentTime">发布日期: <span>2019-10-19</span></div>
        </div>
      </div>
      <div class="knowledge">
        <img alt="" src="../assets/know-5.jpg"/>
        <div class="contentBox">
          <div class="contentTitlt">
            吃药与生物钟有什么关系?
          </div>
          <div class="contentTxt">
            人体自然的生物节律就犹如心脏跳动一样重要，体内无一器官没有各自的节律，节律消失就意味着人体的死亡。医生和药物学家认识到，按一定的时间表服用药物，可以收到更好的药用效果。下面将部分药品服用的最佳时间介绍如下。
          </div>
          <div class="contentTime">发布日期: <span>2019-10-19</span></div>
        </div>
      </div>
      <div class="knowledge">
        <img alt="" src="../assets/know-6.jpg"/>
        <div class="contentBox">
          <div class="contentTitlt">
            清胃黄连丸不宜长期使用
          </div>
          <div class="contentTxt">
            临床表现皮疹多发生于颜面，尤其是颊、额、鼻旁等，皮疹炎症明显，或有口臭口干，脓疱，尿黄便结，苔黄，舌质红，脉数。此时，可以服用清胃黄连丸，能起到很好的疗效。那么，清胃黄连丸不良反应是什么?可以长期用吗?
          </div>
          <div class="contentTime">发布日期: <span>2019-10-19</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HealthKnowledge',
  components: {
  }
}
</script>

<style lang="scss" scoped>
.tips{
  width: 1200px;
  height: 60px;
  line-height: 60px;
  background: 0;
  color: #48576a;
  font-size: 14px;
  text-align: left;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 10px;
}
.knowBox{
  width: 1220px;
  height: auto;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  background: #FFF;
  .knowledge{
    width: 100%;
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    padding: 10px;
    transition: all .5s;
    cursor: pointer;
    overflow: hidden;
    img{
      width: 200px;
      height: auto;
      float: left;
      margin-right: 20px;
    }
    .contentBox{
      float: left;
      width: 760px;
      color: #666;
      .contentTitlt{
        line-height: 2;
        font-size: 16px;
        text-align: left;
      }
      .contentTxt{
        line-height: 1.5;
        font-size: 14px;
        text-align: left;
      }
      .contentTime{
        margin-top: 30px;
        color: #666;
        font-size: 12px;
        text-align: left;
        span{
          margin-left: 10px;
        }
      }
    }
  }
  .knowledge:hover{
    box-shadow: 0px 0px 30px #CCC;
  }
}

</style>
